const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.enablePerformanceObserver();
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.appendSellingPlanInput();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.listenToOneTimeRadioChange();
    this.handleOneTimePlaceholderVisibility();
    this.updatePrice();
    this.updateThemePrice();
    this.listenToAddToCartClick();
    this.listenToCartChanges();
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get addToCartForm() {
    const forms = this.shopifySection.querySelectorAll('[action*="/cart/add"]');
    for (const form of forms) {
      if (form.querySelector('[data-add-to-cart]')) return form;
    }
    return forms[0] || null;
  }

  get variantIdInput() {
    return (
      this.addToCartForm?.querySelector('select[name="id"]') ||
      this.addToCartForm?.querySelector('input[name="id"]') ||
      this.shopifySection.querySelector('select[name="id"]') ||
      this.shopifySection.querySelector('input[name="id"]')
    );
  }

  get currentVariantId() {
    return this.variantIdInput?.value;
  }

  appendSellingPlanInput() {
    if (!this.addToCartForm) return;
    if (this.addToCartForm.querySelector('.selling-plan-id-in-form')) return;

    const source = this.shopifySection.querySelector('.selected-selling-plan-id');
    if (!source) return;

    const clone = source.cloneNode();
    clone.classList.add('selling-plan-id-in-form');
    this.addToCartForm.appendChild(clone);

    if (!this.addToCartForm.querySelector('input[name="quantity"]')) {
      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      this.addToCartForm.appendChild(qtyInput);
    }
  }

  disableAppstleRadiosForSubmit() {
    const radios = this.addToCartForm?.querySelectorAll(
      '#appstle_subscription_widget0 input[name="selling_plan"]'
    );
    radios?.forEach((r) => (r.name = '_selling_plan_disabled'));
    return radios;
  }

  restoreAppstleRadios(radios) {
    radios?.forEach((r) => (r.name = 'selling_plan'));
  }

  get sellingPlanInputInForm() {
    return this.addToCartForm?.querySelector('.selling-plan-id-in-form');
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll('.selected-selling-plan-id');
  }

  get quantityInput() {
    return this.addToCartForm?.querySelector('input[name="quantity"]');
  }

  updateSellingPlanInputsValues() {
    const value = this.sellingPlanInputValue;
    const qty   = this.getQuantityForSelectedPlan();

    if (this.sellingPlanInputInForm) {
      this.sellingPlanInputInForm.value = value;
    }

    this.sellingPlanInputs.forEach((input) => {
      input.value = value;
      input.dataset.quantity = String(qty);
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? '';
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
  }

  set selectedPurchaseOption(val) {
    this._selectedPurchaseOption = val;
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id="${this.currentVariantId}"]`
    );
  }

  handleSellingPlanFormVisibility() {
    this.shopifySection.querySelectorAll('.selling_plan_theme_integration').forEach((s) => {
      s.classList.toggle(hiddenClass, s.dataset.variantId !== this.currentVariantId);
    });
  }

  handleOneTimePlaceholderVisibility() {
    this.shopifySection.querySelectorAll('.selling_plan_one_time').forEach((p) => {
      p.classList.toggle(hiddenClass, p.dataset.variantId !== this.currentVariantId);
    });
  }

  get visibleOneTimeRadio() {
    return this.shopifySection.querySelector(
      `.selling_plan_one_time[data-variant-id="${this.currentVariantId}"] .selling_plan_one_time_radio`
    );
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.handleOneTimePlaceholderVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
    this.listenToOneTimeRadioChange();
  }

  listenToVariantChange() {
    const input = this.variantIdInput;
    if (!input) return;
    if (input.tagName === 'SELECT') {
      input.addEventListener('change', () => this.handleVariantChange());
    } else {
      new MutationObserver(() => this.handleVariantChange())
        .observe(input, { attributes: true });
    }
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"][data-radio-type="selling_plan"]')
      .forEach((radio) => {
        const fresh = radio.cloneNode(true);
        radio.parentNode.replaceChild(fresh, radio);
        fresh.addEventListener('change', () => {
          this.selectedPurchaseOption = fresh;
          this.updateSellingPlanInputsValues();
          this.updatePrice();
          this.updateThemePrice();

          const selectedPurchaseOption = this.selectedPurchaseOption;

          const priceText = selectedPurchaseOption?.dataset.variantChangedPriceRegular;

          if (priceText) {
            const priceElement = document.querySelector('#ProductPrice span');
            if (priceElement) {
              priceElement.textContent = priceText;
            }
          }

          const btn = document.querySelector(
            `#shopify-section-${this.sectionId} [data-add-to-cart]`
          );
          if (btn) btn.style.pointerEvents = '';
        });
      });
  }

  listenToOneTimeRadioChange() {
    const radio = this.visibleOneTimeRadio;
    if (!radio) return;
    const fresh = radio.cloneNode(true);
    radio.parentNode.replaceChild(fresh, radio);

    fresh.addEventListener('change', () => {
      if (this.sellingPlanInputInForm) this.sellingPlanInputInForm.value = '';
      this.sellingPlanInputs.forEach((input) => {
        input.value = '';
        input.dataset.quantity = '1';
      });
      this.showRegularPrice();
      this.hideSalePrice();
      this.priceElement?.classList.remove('price--on-sale');

      const qtyInput = document.querySelector(
        `#shopify-section-${this.sectionId} form[action*="/cart/add"] input[name="quantity"]`
      );
      if (qtyInput) qtyInput.value = '1';

      const button = document.querySelector(
        `#shopify-section-${this.sectionId} [data-add-to-cart]`
      );

      if (button) button.style.pointerEvents = 'none';
      button?.click();
      setTimeout(() => {
        if (button) button.style.pointerEvents = '';
        const firstPlan = this.visibleSellingPlanForm?.querySelector(
          'input[type="radio"][data-radio-type="selling_plan"]'
        );
        if (firstPlan) {
          firstPlan.checked = true;
          firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 2000);
      this.updateCartBubble();
      this.updateThemePrice();
    });
  }

  updateCartBubble() {
    setTimeout(() => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const bubble = document.querySelector('.cart-link__bubble-num');
          const bubbleWrapper = document.querySelector('.cart-link__bubble');
          if (bubble) bubble.textContent = cart.item_count;
          if (bubbleWrapper) {
            if (cart.item_count > 0) {
              bubbleWrapper.classList.add('cart-link__bubble--visible');
            } else {
              bubbleWrapper.classList.remove('cart-link__bubble--visible');
            }
          }
        });
    }, 800);
  }

  listenToCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;
        const url = new URL(entry.name);
        if (
          url.pathname.includes('/cart/change') ||
          url.pathname.includes('/cart/remove') ||
          url.pathname.includes('/cart/update')
        ) {
          this.updateCartBubble();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }

  getQuantityForSelectedPlan() {
    const selected = this.selectedPurchaseOption;
    if (!selected || selected.dataset.radioType === 'one_time_purchase') return 1;
    const all = Array.from(
      this.visibleSellingPlanForm?.querySelectorAll(
        'input[type="radio"][data-radio-type="selling_plan"]'
      ) ?? []
    );
    const index = all.indexOf(selected);
    return index >= 0 ? index + 1 : 1;
  }

  listenToAddToCartClick() {
    const button = this.shopifySection.querySelector('[data-add-to-cart]');
    if (!button) return;

    const sectionId = this.sectionId;

    button.addEventListener(
      'click',
      () => {
        const spInput = document.querySelector(
          `#shopify-section-${sectionId} .selected-selling-plan-id`
        );
        const qty = parseInt(spInput?.dataset.quantity, 10);
        const quantityInput = document.querySelector(
          `#shopify-section-${sectionId} [action*="/cart/add"] input[name="quantity"]`
        );
        if (quantityInput) {
          quantityInput.value = Number.isFinite(qty) ? qty : 1;
        }

        const appstleRadios = this.disableAppstleRadiosForSubmit();
        setTimeout(() => this.restoreAppstleRadios(appstleRadios), 500);
        this.updateCartBubble();
      },
      true
    );
  }

  get priceElement() {
    return this.shopifySection.querySelector('.price');
  }

  get regularPriceElement() {
    return this.shopifySection.querySelector('.price__regular');
  }

  get salePriceElement() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get salePriceValue() {
    return this.salePriceElement?.querySelector('.price-item--sale');
  }

  get regularPriceValue() {
    return this.salePriceElement?.querySelector('.price-item--regular');
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption?.dataset.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption?.dataset.variantCompareAtPrice;
  }

  updatePrice() {
    if (
      !this.selectedPurchaseOptionComparedAtPrice ||
      this.selectedPurchaseOptionComparedAtPrice === this.selectedPurchaseOptionPrice
    ) {
      this.showRegularPrice();
      this.hideSalePrice();
      this.priceElement?.classList.remove('price--on-sale');
    } else {
      this.showSalePrice();
      this.hideRegularPrice();
      this.priceElement?.classList.add('price--on-sale');
    }
  }

  updateThemePrice() {
    const priceEl = this.shopifySection.querySelector('[data-product-price]');
    if (!priceEl) return;

    const raw = this.selectedPurchaseOption?.dataset.variantPrice
      ?? this.visibleOneTimeRadio?.dataset.variantPrice;
    const rawCompare = this.selectedPurchaseOption?.dataset.variantCompareAtPrice
      ?? this.visibleOneTimeRadio?.dataset.variantCompareAtPrice;

    if (!raw) return;

    const cents = parseInt(raw.replace(/\D/g, ''), 10);
    if (isNaN(cents)) return;

    const dollars = Math.floor(cents / 100);
    const remainder = String(cents % 100).padStart(2, '0');

    priceEl.innerHTML = `
      <span aria-hidden="true">$${dollars}<sup>${remainder}</sup></span>
      <span class="visually-hidden">$${dollars}.${remainder}</span>
    `;
    priceEl.classList.toggle('on-sale', !!(rawCompare && parseInt(rawCompare.replace(/\D/g, ''), 10) > cents));

    let comparePriceWrap = this.shopifySection.querySelector('[data-product-price-wrap]');
    let comparePriceEl = this.shopifySection.querySelector('[data-compare-price]');
    const savingsEl = this.shopifySection.querySelector('[data-save-price]');

    if (!comparePriceWrap) {
      comparePriceWrap = document.createElement('span');
      comparePriceWrap.setAttribute('data-product-price-wrap', '');
      comparePriceWrap.className = 'hide';
      priceEl.insertAdjacentElement('beforebegin', comparePriceWrap);
    }

    if (!comparePriceEl) {
      comparePriceEl = document.createElement('span');
      comparePriceEl.setAttribute('data-compare-price', '');
      comparePriceEl.className = 'product__price product__price--compare';
      comparePriceWrap.appendChild(comparePriceEl);
    }

    if (rawCompare) {
      const compareCents = parseInt(rawCompare.replace(/\D/g, ''), 10);
      const savedCents = compareCents - cents;

      if (savedCents > 0) {
        const cDollars = Math.floor(compareCents / 100);
        const cRemainder = String(compareCents % 100).padStart(2, '0');
        comparePriceEl.innerHTML = `
          <span aria-hidden="true">$${cDollars}<sup>${cRemainder}</sup></span>
          <span class="visually-hidden">$${cDollars}.${cRemainder}</span>
        `;
        comparePriceEl.removeAttribute('style');
        comparePriceWrap.classList.remove('hide');

        if (savingsEl) {
          const savedDollars = Math.floor(savedCents / 100);
          const savedRemainder = String(savedCents % 100).padStart(2, '0');
          savingsEl.textContent = `Save $${savedDollars}.${savedRemainder}`;
          savingsEl.classList.remove('hide');
        }
      } else {
        comparePriceWrap.classList.add('hide');
        if (savingsEl) { savingsEl.textContent = ''; savingsEl.classList.add('hide'); }
      }
    } else {
      comparePriceWrap.classList.add('hide');
      if (savingsEl) { savingsEl.textContent = ''; savingsEl.classList.add('hide'); }
    }
  }

  hideSalePrice() {
    if (this.salePriceElement) this.salePriceElement.style.display = 'none';
  }

  hideRegularPrice() {
    if (this.regularPriceElement) this.regularPriceElement.style.display = 'none';
  }

  showRegularPrice() {
    if (this.regularPriceElement) this.regularPriceElement.style.display = 'block';
    if (this.salePriceElement) this.salePriceElement.style.display = 'none';
  }

  showSalePrice() {
    if (!this.salePriceElement) return;
    this.salePriceElement.style.display = 'block';
    if (this.regularPriceValue)
      this.regularPriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice;
    if (this.salePriceValue)
      this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  enablePerformanceObserver() {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;
        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          this.updatePrice();
          this.updateThemePrice();
        }
      });
    });
    observer.observe({ entryTypes: ['resource'] });
  }
}

document
  .querySelectorAll('.selling_plan_app_container')
  .forEach((container) => new SellingPlansWidget(container));


